// src/utils/permissoes.ts

export type Usuario = {
    permissions?: string[];
  };
  
  /**
   * Verifica se o usuário possui pelo menos uma das permissões requeridas
   */
  export const temPermissao = (
    user: Usuario | null | undefined,
    permissoesRequeridas: string[] = []
  ): boolean => {
    if (!user?.permissions) return false;
  
    // Se tem todas as permissões
    if (user.permissions.includes('allPermissions')) return true;
  
    // Retorna true se tiver pelo menos uma das permissões
    return permissoesRequeridas.some(p => user.permissions!.includes(p));
  };
  
  /**
   * Verifica se o usuário possui todas as permissões requeridas
   */
  export const temTodasPermissoes = (
    user: Usuario | null | undefined,
    permissoesRequeridas: string[] = []
  ): boolean => {
    if (!user?.permissions) return false;
  
    if (user.permissions.includes('allPermissions')) return true;
  
    return permissoesRequeridas.every(p => user.permissions!.includes(p));
  };
  